import { Section } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { ITransfer } from '@zmedia/bm-soccer-ui/interface';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import TransferService from '@zmedia/bm-soccer-ui/service/TransferService';
import { useAsync } from 'react-use';
import { TransferList } from '@zmedia/bm-soccer-ui/modules/transfer';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';

export function TournamentTransfer(props: any) {
    const { id, seasonId } = props;

    const params = {
        listId: id,
        seasonId: seasonId,
        listType: 'byTournament',
    };

    let items: ITransfer[] = props.items || [];
    if (ArrayUtils.isEmpty(items)) {
        const state = useAsync(() => TransferService.getList(params), [id]);
        const data = state.value?.data || {};

        items = data.items || [];
    }

    if (ArrayUtils.isEmpty(items)) {
        return (
            <Section>
                <Empty content="Chưa có thông tin chuyển nhượng"></Empty>
            </Section>
        );
    }

    return <TransferList items={items} />;
}

export default memo(TournamentTransfer);
